import { createFileRoute } from "@tanstack/react-router";
import { ManageInvitationsPage } from "@/components/pages/ManageInvitationsPage";

export const Route = createFileRoute("/invitations/manage")({
  component: ManageInvitationsPage,
});
